{
  "de": {
    "published": {
      "labels": {
        "notPublished": "Nicht veröffentlicht",
        "publishedCustomer": "Veröffentlicht für Kunden",
        "publishedCustomerPartners": "Veröffentlicht für Kunden & Partner",
        "publishedPartners": "Veröffentlicht für Partner"
      },
      "publish_mode": {
        "inherit": "Vorlage folgen",
        "inherit_info": "Behält den veröffentlichten oder unveröffentlichten Status jedes Elements aus der Vorlage bei"
      }
    }
  }
}
